import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Container } from 'reactstrap';
import { FaUserSecret, FaSignOutAlt } from 'react-icons/fa';
import './ImpersonationBanner.css';

const ImpersonationBanner = ({ impersonatedUser, onStopImpersonation }) => {
 // console.log('🎨 ImpersonationBanner render - impersonatedUser:', impersonatedUser);
  
  if (!impersonatedUser) {
    //console.log('⚠️ ImpersonationBanner - No impersonatedUser, not rendering');
    return null;
  }

  //console.log('✅ ImpersonationBanner - Rendering banner for:', impersonatedUser.username || impersonatedUser.user_id);

  return (
    <div className="impersonation-banner">
      <Container fluid>
        <Alert color="warning" className="mb-0 d-flex align-items-center justify-content-between py-2">
          <div className="d-flex align-items-center">
            <FaUserSecret className="me-2" size={20} />
            <strong className="me-2">Impersonation Mode:</strong>
            <span>
              You are viewing as{' '}
              <strong>{impersonatedUser.username || impersonatedUser.user_id}</strong>
              {impersonatedUser.email && (
                <span className="text-muted ms-2">({impersonatedUser.email})</span>
              )}
            </span>
          </div>
          <Button
            color="danger"
            size="sm"
            onClick={onStopImpersonation}
            className="d-flex align-items-center"
          >
            <FaSignOutAlt className="me-1" />
            Return to Admin View
          </Button>
        </Alert>
      </Container>
    </div>
  );
};

ImpersonationBanner.propTypes = {
  impersonatedUser: PropTypes.shape({
    user_id: PropTypes.string,
    username: PropTypes.string,
    email: PropTypes.string
  }),
  onStopImpersonation: PropTypes.func.isRequired
};

export default ImpersonationBanner;
